//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import 'devextreme/ui/button'
import 'devextreme/ui/switch'
import 'devextreme/ui/popup'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ColumnModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'
import { GridButtonBridge } from '../../common/grid-button/grid-button.directive'
import { i18n } from './../i18n/common.i18n'
import { GridOptions, GridTypes } from '../grid/grid.controller'
import { Md5 } from '../../../helpers/md5-helper'
import { GridBridge } from '../common.interfaces'
import { OpDeviceHierarchy, OpDevice } from '../../../models/core'
import { IUserSession } from '../../../helpers/user-session'
import { TemplateHelper, ConfigHelper } from '../../../helpers'
import { Enums } from '../../../models/common/enums'

//#region Asset Imports

import './grid-slot-edit.scss'
import * as TEMPLATE from './grid-slot-edit.tpl.html'

//#endregion

interface GridSlotEditScope extends ng.IScope {
    gridOptions: GridOptions
    grid: DevExpress.ui.dxDataGrid
    rowSelected: boolean
    bridge: GridButtonBridge
    saveButtonDisabled: boolean

    toggleStateButtonIcon(): string
    toggleState(): void
    switchState: boolean
    stateSwitch: DevExpress.ui.dxSwitch
    stateSwitchOptions: DevExpress.ui.dxSwitchOptions
    removeButtonOptions: DevExpress.ui.dxButtonOptions
    saveButtonOptions: DevExpress.ui.dxButtonOptions

    source: GridBridge
    popupOptions: DevExpress.ui.dxPopupOptions
    popupVisible: boolean

    changed: OpDeviceHierarchy[]
    inputHierarchy: OpDeviceHierarchy[]
}

export class GridSlotEditDirective
    implements ng.IDirective {
    previousSaveRequestMd5: string
    previousElementsMd5: string
    saveFailed: boolean = false

    constructor() {

    }

    restrict = 'E'
    scope = {
        source: '='
    }
    template = TEMPLATE

    link = (scope, element, attrs) => {
        scope.$watch("source", value => {
            scope.source = value
        })
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary', 'userSession', ($scope: GridSlotEditScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: IUserSession) => {
        $scope.popupVisible = false
        $scope.popupOptions = {
            showTitle: true,
            showCloseButton: true,
            title: $scope.source.title,
            bindingOptions: {
                visible: 'popupVisible'
            },
            onHiding: () => {
                $scope.$root.$broadcast(EventsNames.CLOSE_GRID_EDIT_POPUP + $scope.source.popupId)
            },
            onShowing: () => {
                this.previousSaveRequestMd5 = ""
                this.previousElementsMd5 = ""
            }
        }

        $scope.$on(EventsNames.OPEN_GRID_EDIT_POPUP + $scope.source.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
            if ($scope.grid) {
                $scope.saveButtonDisabled = true
                $scope.grid.repaint()
            }
            load()
            $scope.popupVisible = true
        })

        $scope.switchState = null

        $scope.stateSwitchOptions = {
            height: '100%',
            onInitialized: e => {
                $scope.stateSwitch = e.component
            },
            onValueChanged: (e) => {
                if ($scope.grid && e.event) {
                    const rowData: OpDeviceHierarchy[] = $scope.grid.getSelectedRowsData()
                    const currentMd5: string = Md5.init(rowData)
                    if (this.previousElementsMd5 !== currentMd5) {
                        this.previousElementsMd5 = currentMd5
                        if (rowData.length) {
                            const hierarhy: OpDeviceHierarchy = rowData[0]

                            hierarhy.isActive = e.value
                            $scope.saveButtonDisabled = false

                            var isAlreadyInChanged = false

                            if (!$scope.changed)
                                $scope.changed = []

                            $scope.changed.forEach((changed: OpDeviceHierarchy) => {
                                if (changed.idDeviceHierarchy == hierarhy.idDeviceHierarchy) {
                                    changed.isActive = e.value
                                    isAlreadyInChanged = true
                                }
                            })

                            if (!isAlreadyInChanged)
                                $scope.changed.push(hierarhy)

                            hierarhy.opState = Enums.OpChangeState.Modified

                            $timeout(() => {
                                $scope.grid.clearSelection()
                            })
                        }
                    }
                }
            },
            bindingOptions: {
                disabled: '!rowSelected',
                value: 'switchState'
            }
        }

        var clearSlot = () => {
            if ($scope.grid) {
                const entity: OpDeviceHierarchy = (<OpDeviceHierarchy>$scope.grid.getSelectedRowsData()[0])
                entity.device = null;
                entity.serialNbr = null;

                $scope.saveButtonDisabled = false

                var isAlreadyInChanged = false

                if (!$scope.changed)
                    $scope.changed = []

                $scope.changed.forEach((changed: OpDeviceHierarchy) => {
                    if (changed.idDeviceHierarchy == entity.idDeviceHierarchy) {
                        changed.device = null
                        changed.serialNbr = null
                        isAlreadyInChanged = true
                    }
                })

                if (!isAlreadyInChanged) {
                    $scope.changed.push(entity)
                }

                entity.opState = Enums.OpChangeState.Modified

                $timeout(() => {
                    $scope.grid.clearSelection()
                })
            }
        }

        $scope.rowSelected = false

        var isSlotSelected = () => {
            return $scope.grid ? $scope.grid.getSelectedRowKeys().length != 0 : false
        }

        $scope.saveButtonDisabled = true

        var saveChanges = () => {
            if ($scope.source.onSubmit) {
                const currentMd5: string = Md5.init($scope.changed)
                if (this.previousSaveRequestMd5 !== currentMd5 || this.saveFailed) {
                    this.previousSaveRequestMd5 = currentMd5

                    const currentHierarchy: OpDeviceHierarchy[] = $scope.grid.option("dataSource").items()

                    currentHierarchy.forEach((hierarchy: OpDeviceHierarchy) => {
                        let source: OpDeviceHierarchy = null

                        for (let item of $scope.inputHierarchy) {
                            if (item.idDeviceHierarchy == hierarchy.idDeviceHierarchy) {
                                source = item
                                break
                            }
                        }

                        if (source != null) {
                            if (source.serialNbr == null && hierarchy.serialNbr != null) {
                                hierarchy.opState = Enums.OpChangeState.New
                            } else if (source.serialNbr != null && hierarchy.serialNbr == null) {
                                hierarchy.opState = Enums.OpChangeState.Delete
                            } else if (source.serialNbr != hierarchy.serialNbr
                                || source.isActive != hierarchy.isActive) {
                                hierarchy.opState = Enums.OpChangeState.Modified
                            } else {
                                hierarchy.opState = Enums.OpChangeState.Loaded
                            }
                        } else {
                            hierarchy.opState = Enums.OpChangeState.Loaded
                        }

                    })

                    $scope.source.onSubmit(null, null, currentHierarchy).then((result: boolean) => {
                        if (result) {
                            this.saveFailed = false
                            $scope.source.items.length = 0
                            $scope.grid.option("dataSource").items().forEach((item: OpDeviceHierarchy) => {
                                $scope.source.items.push(item)
                                item.opState = Enums.OpChangeState.Loaded
                            })

                            $scope.grid.refresh()

                            $scope.saveButtonDisabled = true
                        }
                        else {
                            this.saveFailed = true
                        }
                    }).catch(() => {
                        this.saveFailed = true
                    })
                }
            }
        }

        $scope.$watch(isSlotSelected, (value) => {
            $scope.rowSelected = $scope.bridge.enabled = value
        })

        var load = () => {
            $scope.inputHierarchy = []
            if ($scope.source.items) {
                $scope.source.items.forEach((hierarchy: OpDeviceHierarchy) => {
                    $scope.inputHierarchy.push(new OpDeviceHierarchy(hierarchy))
                })
            }

            $scope.gridOptions = {
                name: 'gridslotedit',
                type: GridTypes.NO_SEARCH_BAR_SMALL,
                buttonsOptions: {
                    enabled: false
                },
                columnsDictionary: $scope.source.columns,
                dataSource: new DataSource($scope.source.items),
                onInitialized: e => {
                    $scope.grid = e.component
                },
                selection: {
                    mode: 'single'
                },
                onRowPrepared: (e: any) => {
                    if (e.rowType == "data" && e.data instanceof OpDeviceHierarchy) {
                        const hierarchy: OpDeviceHierarchy = <OpDeviceHierarchy>e.data

                        if (hierarchy.opState == Enums.OpChangeState.Modified) {
                            $(e.rowElement).css('font-style', 'italic')
                        }
                    }
                },
                onSelectionChanged: e => {
                    const rowsData: OpDeviceHierarchy[] = $scope.grid.getSelectedRowsData()
                    if (rowsData && rowsData[0]) {
                        $timeout(() => {
                            $scope.switchState = (rowsData[0].isActive || false)
                            $scope.stateSwitch.option("value", $scope.switchState)
                            $scope.stateSwitch.repaint()
                        })
                    }
                },
                allowColumnReordering: $scope.source.allowColumnReordering != null ? $scope.source.allowColumnReordering : true
            }
        }

        $scope.bridge = {
            idReferenceType: Enums.ReferenceType.SerialNbr,
            getDataSourceMethod: userSession.getDataProvider().Device.getDeviceFilter,
            onSelect: (e) => {
                $timeout(() => {
                    const device: OpDevice = new OpDevice(e.data['__BUSINESS_OBJECT__'])

                    const deviceHierarchy: OpDeviceHierarchy = (<OpDeviceHierarchy>$scope.grid.getSelectedRowsData()[0])

                    deviceHierarchy.opState = Enums.OpChangeState.Modified

                    deviceHierarchy.device = device
                    deviceHierarchy.serialNbr = device.serialNbr

                    $scope.saveButtonDisabled = false

                    var isAlreadyInChanged = false

                    if (!$scope.changed)
                        $scope.changed = []

                    $scope.changed.forEach((changed: OpDeviceHierarchy) => {
                        if (changed.idDeviceHierarchy == deviceHierarchy.idDeviceHierarchy) {
                            changed.device = deviceHierarchy.device
                            changed.serialNbr = deviceHierarchy.serialNbr
                            isAlreadyInChanged = true
                        }
                    })

                    if (!isAlreadyInChanged)
                        $scope.changed.push(deviceHierarchy)

                    $timeout(() => {
                        $scope.grid.clearSelection()
                    })
                })
            },
            dataRequest: null,
            columnRequest: (): ng.IPromise<any> => {
                const defer: ng.IDeferred<any> = $q.defer<any>()

                userSession
                    .getDataProvider()
                    .System
                    .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__POPUP_GRID_PARAMS,
                        Enums.SimaxModuleName.Device,
                        { groupReferenceType: Enums.ReferenceType.IdDistributor, groupReferenceValue: userSession.getLoggedOperator().idDistributor, viewReferenceType: Enums.ReferenceType.SerialNbr })
                    .then((columns: ColumnModel[]) => {
                        defer.resolve(columns)
                    })
                    .fail((error: any) => defer.reject(error))

                return defer.promise
            },
            enabled: $scope.rowSelected,
            name: null
        }

        $scope.removeButtonOptions = {
            onClick: clearSlot,
            template: TemplateHelper.getIcon(ConfigHelper.Icon.REMOVE, userSession),
            bindingOptions: {
                disabled: '!rowSelected'
            }
        }

        $scope.saveButtonOptions = {
            text: i18n('Common', 'Apply'),
            onClick: saveChanges,
            bindingOptions: {
                disabled: 'saveButtonDisabled'
            }
        }

        $scope.$watchCollection('source.items', (items: any[]) => {
            if ($scope.grid) {
                $scope.grid.option("dataSource").store().clear()
                items.forEach((item) => {
                    $scope.grid.option("dataSource").store().insert(item)
                })
                $scope.grid.refresh()
            }
        })
    }]
}